export const IOS8601 = 'YYYY-MM-DD HH:mm:ss';
